var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEnquiry = function SvgEnquiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "url(#enquiry_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.21 8c.6 0 1.167.255 1.598.717.447.479.692 1.118.692 1.8v8.126c0 1.387-1.027 2.516-2.29 2.516h-4.19l-.232.15c-.628.41-1.856 1.066-2.843 1.594-.73.39-1.36.728-1.697.934-.172.105-.331.163-.449.163a.25.25 0 0 1-.12-.028c-.04-.02-.091-.057-.136-.159a.674.674 0 0 1-.047-.167l-.003-2.487H9.789C8.527 21.16 7.5 20.03 7.5 18.643v-8.126C7.5 9.129 8.527 8 9.79 8h11.42Zm-7.172 2.57c-.277-.278-.706-.293-.96-.035-.252.257-.231.69.046.967l1.712 1.708v.216H13.4c-.39 0-.707.293-.707.655 0 .362.316.656.707.656h1.439l.001 1.008H13.4c-.39 0-.707.294-.707.656 0 .361.316.655.707.655h1.442l.002 1.318c0 .394.292.713.65.713.36 0 .651-.319.651-.713l-.002-1.318h1.438c.39 0 .707-.294.707-.655 0-.362-.316-.656-.707-.656h-1.44l-.002-1.008h1.442c.39 0 .707-.294.707-.656 0-.362-.316-.655-.707-.655h-1.444v-.156l1.728-1.762c.274-.28.29-.712.035-.967-.256-.254-.686-.235-.96.046l-1.426 1.453-1.476-1.47Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "enquiry_svg__a",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65DCC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C8A4"
  })))));
};

export default SvgEnquiry;